import { Card, CardContent } from '@mui/material';
import { FunctionComponent } from 'react';

import { User } from '../../../apollo/__generated__/graphql';
import { HeaderCard } from '../../../event/components/HeaderCard';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { useCurrentUserQuery } from '../../hooks/useCurrentUserQuery';
import { UserInfosForm } from './components/UserInfosForm/UserInfosForm';

export const UserInfos: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery();

  return (
    <Layout title="Informations utilisateur" activeTab="userInfos">
      <HeaderCard
        title="Complétez vos informations personnelles"
        description="Renseignez votre profil pour finaliser votre inscription et faciliter l'organisation de l'événement."
      />
      <Card>
        <CardContent>
          {currentUserData?.currentUser ? (
            <UserInfosForm currentUser={currentUserData.currentUser as User} />
          ) : null}
        </CardContent>
      </Card>
    </Layout>
  );
};
